import React, { useEffect, useState } from 'react'
import { titleData } from '../../../data/titles'
import { contactPreferencesData } from '../../../data/contactPreferences'
import {
    InputFieldText,
    InputFieldSelect,
    InputFieldTitleSelect,
    FieldGroup,
    Field,
    SubmitButton,
    FormCard,
    InputFieldDate,
} from '../../reusable'
import { FormPartInterface, SaveValueInterface } from '../../../interfaces'
import { Checkbox } from '../../reusable/checkbox'
import { sectionValidation } from '../../../helpers'
import globalStyles from '../../../globals/pages.module.scss'

export const Person = (props: FormPartInterface & { populateData?: any }) => {
    const { saveValueFunct, isActive, assignGroup, populateData } = props
    const [currentStep, setCurrentStep] = useState(0)
    const [postCurrentStep, setPostCurrentStep] = useState(0)
    const [stepData, setStepData] = useState<any>({})
    const [formErrors, setFormErrors] = useState<{ [key: string]: boolean }>({})
    const [showErrors, setShowErrors] = useState(false)
    const [isFormValid, setIsFormValid] = useState(false)

    // console.log('PERSON DATA:' + JSON.stringify(stepData))

    useEffect(() => {
        if (populateData) {
            setStepData({
                title: populateData.title || '',
                firstname: populateData.firstname.trim() || '',
                lastname: populateData.lastname.trim() || '',
                dob: populateData.dob || '',
            })
        }
    }, [populateData])

    // Add new useEffect to validate whenever stepData changes
    useEffect(() => {
        validateForm(true)
    }, [stepData])

    const validateForm = (updateState = false) => {
        const newErrors: { [key: string]: boolean } = {}
        let hasErrors = false

        // Check required fields
        if (!stepData.title?.trim()) {
            newErrors.title = true
            hasErrors = true
        }
        if (!stepData.firstname?.trim()) {
            newErrors.firstname = true
            hasErrors = true
        }
        if (!stepData.lastname?.trim()) {
            newErrors.lastname = true
            hasErrors = true
        }
        if (!stepData.dob?.trim()) {
            newErrors.dob = true
            hasErrors = true
        }

        if (updateState) {
            setFormErrors(newErrors)
            setIsFormValid(!hasErrors)
        }
        return !hasErrors
    }

    const preSaveValueFunct = (dataToSave: SaveValueInterface) => {
        const saved = saveValueFunct(dataToSave)
        setStepData((prevData: any) => ({
            ...prevData,
            [dataToSave.field]: dataToSave.value,
        }))
        // Clear error for this field if it has a value
        if (dataToSave.value.trim()) {
            setFormErrors((prev) => ({
                ...prev,
                [dataToSave.field]: false,
            }))
        }
        return saved
    }

    const handleNext = () => {
        setShowErrors(true)
        if (!validateForm()) {
            return
        }

        Object.keys(stepData).forEach((field) => {
            saveValueFunct({ field, value: stepData[field] })
        })

        setTimeout(() => {
            assignGroup('contact')
        }, 400)
    }

    return isActive === 'person' ? (
        <FieldGroup title="Contact Information">
            <FormCard assignPostStep={setPostCurrentStep} step={currentStep} onBack={() => assignGroup('address')}>
                <h3>Who's Making a Claim?</h3>
                <p>Please enter your name and date of birth so we can associate all your car finance claims.</p>
                <Field fieldLabel="Title" labelPosition="left" enhanced={true}>
                    <InputFieldTitleSelect
                        fieldName="title"
                        saveValue={preSaveValueFunct}
                        options={titleData}
                        populateValue={titleData.find((option) => option.value === stepData.title)}
                        enhanced={true}
                        required={true}
                        showErrors={showErrors}
                    />
                </Field>
                <div className={`${globalStyles.nameFields} ${globalStyles.nameFields}`}>
                    <Field
                        fieldLabel="Firstname"
                        labelPosition="left"
                        extraStyle={{ flex: 1, margin: '0 0 20px' }}
                        enhanced={true}
                    >
                        <InputFieldText
                            fieldName="firstname"
                            saveValue={preSaveValueFunct}
                            populateValue={stepData.firstname || ''}
                            enhanced={true}
                            required={true}
                            showErrors={showErrors}
                        />
                    </Field>
                    <Field
                        fieldLabel="Lastname"
                        labelPosition="left"
                        extraStyle={{ flex: 1, margin: '0 0 20px' }}
                        enhanced={true}
                    >
                        <InputFieldText
                            fieldName="lastname"
                            saveValue={preSaveValueFunct}
                            populateValue={stepData.lastname || ''}
                            enhanced={true}
                            required={true}
                            showErrors={showErrors}
                        />
                    </Field>
                </div>
                <Field fieldLabel="Date of Birth" labelPosition="left" enhanced={true}>
                    <InputFieldDate
                        fieldName="dob"
                        saveValue={preSaveValueFunct}
                        populateValue={stepData.dob || ''}
                        enhanced={true}
                        required={true}
                        showErrors={showErrors}
                    />
                </Field>
                <SubmitButton text="Continue" btnType="primary" onClick={handleNext} disabled={!isFormValid} />
            </FormCard>
        </FieldGroup>
    ) : (
        <></>
    )
}
